import { QUERY_TRIAGE_POLICIES } from '../../constants/actions/policies';

export function queryTriagePolicies(payload) {
    return {
        type: QUERY_TRIAGE_POLICIES,
        payload,
    };
}
